/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit New/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AssignedDoctor from './AssignedDoctor/index'
import DateOfBirth from './DateOfBirth/index'
import FirstName from './FirstName/index'
import Gender from './Gender/index'
import LastName from './LastName/index'
import MiddleName from './MiddleName/index'
import React from 'react'
import ReferralSource from './ReferralSource/index'
import Ssn from './Ssn/index'
import Title from './Title/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function New({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/PatientSelect/Content/Content/New"
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="New.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-l16': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-2-l16': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-3-l16': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-4-l16': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--btlr-5-l16': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--btrr-6-l16': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bbrr-7-l16': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bblr-8-l16': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bc-9-l16': dtColorsNeutral200,'--g-10-l16': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="New.Horizontal"
  data-view-path={viewPath}
 style={{'--g-10-l16': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<Title
  viewPath={`${viewPath}/Title`}
/>
<Gender
  viewPath={`${viewPath}/Gender`}
/>
</div>
<FirstName
  viewPath={`${viewPath}/FirstName`}
/>
<MiddleName
  viewPath={`${viewPath}/MiddleName`}
/>
<LastName
  viewPath={`${viewPath}/LastName`}
/>
<DateOfBirth
  viewPath={`${viewPath}/DateOfBirth`}
/>
<Ssn
  viewPath={`${viewPath}/Ssn`}
/>
<AssignedDoctor
  viewPath={`${viewPath}/AssignedDoctor`}
/>
<ReferralSource
  viewPath={`${viewPath}/ReferralSource`}
/>
</div>
{children}
</React.Fragment>)
}